<template>
  <component
    :is="tag"
    :class="{...buttonClasses, ...classes}"
    v-bind="$attrs"
    :type="$attrs.type || 'button'"
    :aria-label="labelText"
  >
    <template v-if="isLoading">
      <span>Loading...</span>
    </template>
    <template v-else>
      <pdl-icon v-if="icon" :name="icon" :size="iconSize" :class="iconStyling" />
      <span v-if="!iconOnly"><slot /></span>
    </template>
  </component>
</template>

<script>
import {PdlButtonMixin} from '@pedal/pdl-shared-libraries';
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  name: 'PdlButton',
  components: {PdlIcon},
  mixins: [PdlButtonMixin],
  inheritAttrs: false,
  props: {
    /**
     * "button" | "input"
     */
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'input'].indexOf(value) !== -1;
      },
    },
    /**
     * Text used to describe the context of the button. A label is required when using an icon-only button,
     * as there is no pairing of visible text with the icon. The text will be added to an aria-label on the button element.
     */
    label: {
      type: String,
      default: undefined,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'button--loading': this.isLoading,
        'button--disabled': this.$attrs.disabled,
      };
    },

    iconSize() {
      if (this.xsmall) {
        return '14';
      } else if (this.small) {
        return '18';
      }
      return '24';
    },
    // Icons Colored Separately from Text (icon styling props only applied with 'text' or 'tertiary' prop)
    iconStyling() {
      if (this.button && (this.text || this.tertiary) && this.iconSuccess) {
        return 'text-green-100';
      } else if (this.button && (this.text || this.tertiary) && this.iconWarning) {
        return 'text-orange-100';
      } else if (this.button && (this.text || this.tertiary) && this.iconAlert) {
        return 'text-red-100';
      }
      return '';
    },
    labelText() {
      return this.iconOnly ? this.label : undefined;
    },
  },
};
</script>

<style lang="scss">
@import './Button.scss';
@import './ButtonGroup.scss';
</style>
